import { Briefcase, TrendingUp } from "lucide-react";
import { experience, stats } from "../../data/resume";

export const Experience = () => {
  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="py-24 md:py-32 bg-ink text-white relative overflow-hidden"
    >
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-[0.06] pointer-events-none">
        <img
          src="https://images.pexels.com/photos/8369211/pexels-photo-8369211.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940"
          alt=""
          className="h-full w-full object-cover"
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="reveal max-w-2xl">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-brass mb-4">
            Experience
          </p>
          <h2 className="font-serif font-semibold text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
            Impact measured in millions.
          </h2>
        </div>

        {experience.map((job) => (
          <div key={job.company} className="mt-16">
            <div className="reveal flex flex-col md:flex-row md:items-end md:justify-between gap-4 pb-8 border-b border-white/15">
              <div className="flex items-start gap-4">
                <span className="flex items-center justify-center h-11 w-11 border border-white/25 text-brass shrink-0">
                  <Briefcase className="h-5 w-5" strokeWidth={1.5} />
                </span>
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl font-medium">
                    {job.role}
                  </h3>
                  <p className="text-slate-300 mt-1">{job.company}</p>
                </div>
              </div>
              <span className="text-sm uppercase tracking-[0.16em] text-slate-400 md:text-right">
                {job.period}
              </span>
            </div>

            <ul className="mt-10 grid md:grid-cols-2 gap-x-12 gap-y-6">
              {job.bullets.map((b, i) => (
                <li
                  key={i}
                  data-testid={`experience-bullet-${i}`}
                  className="reveal flex gap-3 text-slate-200/90 leading-relaxed"
                  style={{ transitionDelay: `${(i % 2) * 0.08}s` }}
                >
                  <TrendingUp className="h-5 w-5 text-brass shrink-0 mt-0.5" strokeWidth={1.5} />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}

        {/* Highlight stat row */}
        <div className="reveal mt-20 grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/15 border border-white/15">
          {stats.map((s) => (
            <div key={s.label} className="bg-ink p-7 text-center">
              <div className="font-serif font-bold text-brass text-3xl lg:text-4xl tracking-tight">
                {s.value}
              </div>
              <div className="mt-2 text-xs uppercase tracking-wider text-slate-400 leading-snug">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
